module.exports = __webpack_public_path__ + "static/media/5f0ec7998bb9357e8ec94ae3.c753f9d7.png";